import { useEffect, useMemo, useState } from "react"
import { promotionsData } from "./PromotionData"
import { useGlobalContext } from "./GlobalContext"
import ModulesLotteryDraw from "../promotions/promotion_modules/modules_lotterDraw"

// Keep the same titles list here so BOTH pages use the same source.
export const hiddenBtnTitles = new Set([
  "Exclusive Rolling Commission",
  "Pera O Bayong",
  "Double Up",
  "JDB Exclusive Promo",
  "Pragmatic Play Daily",
  "JolliPlay Free Spins",
  "Recovery Bonus",
  "Pragmatic Play Zombie School",
  "Jolliplay Exclusive Campaign",
  "FGH RECOVERY BONUS is back!",
  "JolliPlay Free Spins Code",
  "FC Grand Spin-Ale",
  "8's Your Lucky Draw",
  "Flexi-Spin Showdown",
  "8PM Recovery Hour",
  "CQ9 Funalo",
  "Fortune Drops 2026",
  "TPGreat Spins of Fortune",
  "JDB Spin Tournament",
  "Race of Reels: Slots Tournament",
  "PGSoft Global Cash",
  "BNG Splash Spin Into Summer",
  "Jili Grand Slot",
])

export const modalComponents = {
  "2/30 Lottery Draw": ModulesLotteryDraw,
}

export function usePromotionsPage({ modalComponents = {} } = {}) {
  const [currentFilter, setCurrentFilter] = useState("All")
  const [isAnimating, setIsAnimating] = useState(false)
  const [isShowDoubleUp, setIsShowDoubleUp] = useState(false)
  const [isShowViewEntry, setIsShowViewEntry] = useState(false)
  const [activeModal, setActiveModal] = useState(null)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024)
  const [isDepositOpen, setIsDepositOpen] = useState(false)

  const { showMysteryFridayBtn, doubleUpMaxAmount, doubleUpTurnover } =
    useGlobalContext()

  useEffect(() => {
    setIsLoggedIn(localStorage.getItem("isLoggedIn") === "true")
  }, [])

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 1024)
    window.addEventListener("resize", onResize)
    return () => window.removeEventListener("resize", onResize)
  }, [])

  useEffect(() => {
    document.body.style.overflow = activeModal ? "hidden" : "auto"
    return () => (document.body.style.overflow = "auto")
  }, [activeModal])

  const uniqueFilters = useMemo(() => {
    const statuses = Array.from(
      new Set(
        promotionsData.map((p) => p.status).filter((s) => s && s.trim() !== "")
      )
    )
    const order = { daily: 1, weekly: 2 }
    statuses.sort((a, b) => {
      const aKey = order[a.toLowerCase()] || 3
      const bKey = order[b.toLowerCase()] || 3
      return aKey !== bKey ? aKey - bKey : a.localeCompare(b)
    })
    return statuses.length ? ["All", ...statuses] : []
  }, [])

  const filteredPromotions = useMemo(
    () =>
      currentFilter === "All"
        ? promotionsData
        : promotionsData.filter((p) => p.status === currentFilter),
    [currentFilter]
  )

  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  const goPromotionIfGuest = () => {
    if (!isLoggedIn) {
      window.location.href = "/promotion"
      return true
    }
    return false
  }

  const goWallet = () => (window.location.href = "/profile#wallet")

  const handleFilterChange = (filter) => {
    if (filter === currentFilter) return
    setIsAnimating(true)
    setTimeout(() => {
      setCurrentFilter(filter)
      setIsAnimating(false)
    }, 100)
  }

  const openModal = (title) => setActiveModal(title)

  const handlePeraOBayong = () => {
    if (goPromotionIfGuest()) return
    showMysteryFridayBtn ? openModal("Pera O Bayong") : goWallet()
  }

  const handleLeaderboard = (title) => {
    if (goPromotionIfGuest()) return
    openModal(title)
  }

  const handlePrimaryBtnClick = (data) => {
    if (data.specialLink?.trim()) {
      const a = document.createElement("a")
      a.href = data.specialLink
      a.target = "_blank"
      a.rel = "nofollow"
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      return
    }

    if (!data.onClickFunction) return

    if (data.onClickFunction === "handleOpenModule") {
      if (
        data.title === "2/30 Lottery Draw" &&
        !document.body.classList.contains("IsLoggedIn")
      ) {
        window.location.href = "/promotion"
        return
      }

      if (!modalComponents[data.title]) {
        console.warn(`No modal mapped for title: ${data.title}`)
        return
      }

      if (data.title === "Pera O Bayong") return handlePeraOBayong()
      openModal(data.title)
      return
    }

    if (typeof data.onClickFunction === "function") data.onClickFunction()
  }

  return {
    // state
    currentFilter,
    isAnimating,
    isShowDoubleUp,
    isShowViewEntry,
    activeModal,
    isLoggedIn,
    isMobile,
    isDepositOpen,

    // computed
    uniqueFilters,
    filteredPromotions,
    ActiveModal,

    // global context values
    showMysteryFridayBtn,
    doubleUpMaxAmount,
    doubleUpTurnover,

    // setters/actions
    setIsShowDoubleUp,
    setIsShowViewEntry,
    setIsDepositOpen,
    setActiveModal,

    handleFilterChange,
    handlePeraOBayong,
    handleLeaderboard,
    handlePrimaryBtnClick,
  }
}
